import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEraser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 14"
    {...props}
  >
    <path
      fill="#787887"
      d="M15.531 7.563 10.594 12.5h5.031c.188 0 .375.188.375.375v.75a.38.38 0 0 1-.375.375H4.5c-.344 0-.844-.187-1.062-.437l-3-3C.188 10.343 0 9.843 0 9.5c0-.312.188-.812.438-1.031l8-8C8.656.219 9.156.03 9.5.03c.313 0 .813.188 1.031.438l5 5c.25.218.438.718.438 1.031 0 .344-.188.844-.438 1.063M9.5 1.5 6.281 4.719l5 5L14.5 6.5zm-5 11h4l1.719-1.719-5-5L1.5 9.5z"
    />
  </svg>
);
export default SvgEraser;
